// extracted by mini-css-extract-plugin
export var divider = "_g5-7";
export var itemsToggle = "_g5-8";
export var mergeModal = "_g5-1";
export var optionCard = "_g5-4";
export var radioGroup = "_g5-6";
export var radioOption = "_g5-0";
export var selected = "_g5-5";
export var shipmentOptions = "_g5-2";
export var tableOptions = "_g5-3";